import {
  BatteryCharging,
  Disc3,
  Settings2,
  ScanLine,
  Droplets,
  Zap,
  ClipboardCheck,
  LifeBuoy,
} from "lucide-react";
import { useI18n } from "../lib/i18n";

const ICONS = [
  BatteryCharging,
  Disc3,
  Settings2,
  ScanLine,
  Droplets,
  Zap,
  ClipboardCheck,
  LifeBuoy,
];

export const Services = () => {
  const { t } = useI18n();

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-[#0A0A0C]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="font-condensed uppercase text-xs tracking-[0.4em] text-[#E51E1A] mb-4">
              · {t.services.kicker}
            </div>
            <h2 className="font-headings uppercase text-5xl md:text-6xl lg:text-7xl text-white leading-none">
              {t.services.title}
              <br />
              <span className="text-[#E51E1A]">{t.services.titleAccent}</span>
            </h2>
          </div>
          <p className="text-zinc-400 text-lg max-w-md">{t.services.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-zinc-800">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i] || Settings2;
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="group relative border-b border-r border-zinc-800 p-8 hover:bg-[#121215] transition-colors duration-300 cursor-default"
              >
                <div className="absolute top-0 left-0 w-0 h-1 bg-[#E51E1A] group-hover:w-full transition-all duration-500" />
                <div className="absolute top-6 right-6 font-headings text-sm text-zinc-700 tracking-widest">
                  0{i + 1}
                </div>
                <div className="w-14 h-14 flex items-center justify-center bg-[#E51E1A]/10 border border-[#E51E1A]/30 mb-6 group-hover:bg-[#E51E1A] transition-colors">
                  <Icon className="w-7 h-7 text-[#E51E1A] group-hover:text-white transition-colors" strokeWidth={1.8} />
                </div>
                <h3 className="font-headings uppercase text-xl md:text-2xl text-white leading-tight">
                  {s.name}
                </h3>
                <p className="mt-3 text-zinc-400 text-sm leading-relaxed">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
